import FieldConfig from "../../../proto/field-config";
import Task from "../../../../model2/task/task";
import FieldProto from "../../../proto/field-proto";

// used to count tasks in charts for example
export default class FieldTaskCounter extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Tasks count";
        this.label          = "Tasks total";

        this.icon           = 'i5-summary-symbol'

        this.isCountable    = true
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return false
    }

    countValue(model:any):number {
        return 1
    }


}